import Home from 'routes/Home'

export default Home
